const QuoteIcon = ({ className }: { className?: string }) => (
  <svg
    aria-hidden='true'
    width='30'
    height='30'
    viewBox='0 0 30 30'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.8842 5.625L3.98438 5.90538L6.25083 23.6257L14.391 23.3956L13.8889 5.625H13.8842ZM17.7387 24.3189L25.8635 24.375H25.8825L26.0069 6.71751V6.5987L16.0998 6.52868L17.7387 24.3189Z'
      fill='currentColor'
    />
  </svg>
);

export default QuoteIcon;
